<template>
  <section>
    <!--工具条-->
    <el-row class="flex-between">
      <el-col>
        <toolbar
          :buttonList="buttonList"
          @callFunction="callFunction"
        ></toolbar>
      </el-col>
      <el-col class="flex" style="justify-content: flex-end">
        <el-input
          style="width: 250px"
          v-model="phone"
          placeholder="请输入手机号"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="getUsers"
          ></el-button>
        </el-input>
        <el-select
          style="margin-left: 10px"
          v-model="userIdentity"
          placeholder="选择查询用户身份"
          @change="onChangeIdentity"
        >
          <el-option
            v-for="item in userIdentityList"
            :key="item.Id"
            :label="item.Name"
            :value="item.Id"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <!--列表-->
    <el-table
      :data="users"
      highlight-current-row
      @current-change="selectCurrentRow"
      @selection-change="selsChange"
      v-loading="listLoading"
      style="width: 100%"
    >
      <el-table-column type="selection" width="50" align="center">
      </el-table-column>
      <el-table-column type="index" width="80" label="顺序" align="center">
      </el-table-column>
      <el-table-column prop="uRealName" label="昵称" sortable align="center">
      </el-table-column>
      <el-table-column prop="uLoginName" label="登录名" sortable align="center">
      </el-table-column>
      <el-table-column prop="Phone" label="手机号" sortable align="center">
      </el-table-column>
      <el-table-column prop="RoleNames" label="角色" sortable align="center">
        <template slot-scope="scope">
          <el-tag
            :style="{ 'margin-bottom': index >= 0 ? '10px' : '0' }"
            v-for="(item, index) in scope.row.RoleNames"
            :key="item.Id"
            >{{ item }}-{{ index }}</el-tag
          >
        </template>
      </el-table-column>
      <!--<el-table-column prop="name" label="姓名"  sortable>-->
      <!--</el-table-column>-->
      <el-table-column
        prop="sex"
        label="性别"
        align="center"
        :formatter="formatSex"
        sortable
      >
      </el-table-column>
      <el-table-column prop="UserIdentityName" align="center" label="身份">
      </el-table-column>
      <el-table-column label="关联信息" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            style="color: #3558b9"
            @click="onClickOpen(scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        prop="BirthdayTime"
        label="生日"
        :formatter="formatBirthdayTime"
        sortable
      >
      </el-table-column>
      <el-table-column prop="uStatus" label="状态" sortable align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.uStatus == 1 ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.uStatus == 1 ? "正常" : "禁用" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="SchoolName" label="所属幼儿园" align="center">
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            style="color: #3558b9"
            @click="onClickEdit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-button
        type="danger"
        @click="batchRemove"
        :disabled="this.sels.length === 0"
        >批量删除</el-button
      >
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="PageSize"
        :total="total"
        style="float: right"
      >
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" :rules="editFormRules" ref="editForm">
        <el-form-item label="昵称" prop="uRealName">
          <el-input v-model="editForm.uRealName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="登录名" prop="uLoginName">
          <el-input
            v-model="editForm.uLoginName"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <!--<el-form-item label="密码" prop="uLoginPWD">-->
        <!--<el-input v-model="editForm.uLoginPWD" show-password  auto-complete="off"></el-input>-->
        <!--</el-form-item>-->
        <el-form-item label="手机号">
          <el-input v-model="editForm.Phone" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="所属幼儿园" v-if="userInfo.uID == 12">
          <el-select
            v-model="editForm.SchoolId"
            placeholder="请选择"
            @visible-change="onScrollData"
          >
            <el-option
              v-for="item in SchoolList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色" prop="RIDs">
          <el-select multiple v-model="editForm.RIDs" placeholder="请选择角色">
            <el-option :key="0" :label="'未选择角色'" :value="0"></el-option>
            <el-option
              v-for="item in roles"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="性别">
          <el-radio-group v-model="editForm.sex">
            <el-radio class="radio" :label="1">男</el-radio>
            <el-radio class="radio" :label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="年龄">
          <el-input-number
            v-model="editForm.age"
            :min="0"
            :max="200"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="身份">
          <el-select
            v-model="editForm.UserIdentity"
            multiple
            collapse-tags
            style="margin-left: 20px"
            placeholder="请选择"
          >
            <el-option
              v-for="item in userOptions"
              :key="item.Id"
              :label="item.name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="生日">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="editForm.BirthdayTime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="地址">
          <el-input type="textarea" v-model="editForm.Address"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" :rules="addFormRules" ref="addForm">
        <el-form-item label="昵称" prop="uRealName">
          <el-input v-model="addForm.uRealName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="登录名" prop="uLoginName">
          <el-input v-model="addForm.uLoginName" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item label="密码" prop="uLoginPWD">
          <el-input
            v-model="addForm.uLoginPWD"
            show-password
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="addForm.Phone" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="所属幼儿园" v-if="userInfo.uID == 12">
          <el-select
            v-model="addForm.SchoolId"
            placeholder="请选择"
            @visible-change="onScrollData"
          >
            <el-option
              v-for="item in SchoolList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="身份">
          <el-select
            v-model="addForm.UserIdentity"
            multiple
            collapse-tags
            style="margin-left: 20px"
            placeholder="请选择"
          >
            <el-option
              v-for="item in userOptions"
              :key="item.Id"
              :label="item.name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!--<el-form-item label="姓名" prop="name">-->
        <!--<el-input v-model="addForm.name" auto-complete="off"></el-input>-->
        <!--</el-form-item>-->
        <el-form-item label="性别">
          <el-radio-group v-model="addForm.sex">
            <el-radio class="radio" :label="1">男</el-radio>
            <el-radio class="radio" :label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="年龄">
          <el-input-number
            v-model="addForm.age"
            :min="0"
            :max="200"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="生日">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="addForm.BirthdayTime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="地址">
          <el-input type="textarea" v-model="addForm.Address"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <!-- 关联信息 -->
    <el-dialog :visible.sync="relevanceDialogVisible" width="30%">
      <div>
        <el-descriptions
          :title="index == 0 ? '教师信息' : ''"
          v-for="(item, index) in relevance.RelationInfo_Teachers"
          :key="index"
        >
          <el-descriptions-item label="教师姓名">{{
            item.TeacherName
          }}</el-descriptions-item>
          <el-descriptions-item label="学校名称">{{
            item.SchoolName
          }}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions
          :title="index == 0 ? '幼儿信息' : ''"
          v-for="(item, index) in relevance.RelationInfo_Students"
          :key="index"
        >
          <el-descriptions-item label="幼儿姓名">{{
            item.StudentName
          }}</el-descriptions-item>
          <el-descriptions-item label="年级名称">{{
            item.GradeName || "暂无"
          }}</el-descriptions-item>
          <el-descriptions-item label="班级名称">{{
            item.ClassName || "暂无"
          }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="relevanceDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="relevanceDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 重置密码 -->
    <el-dialog
      :visible.sync="dialogVisibleresetpwd"
      width="30%"
      title="重置密码"
    >
      <el-row class="flex-items">
        <el-col class="tui-border flex-center">
          <div style="width: 100px">新密码：</div>
          <el-input v-model="newpwd" placeholder="请输入新密码"></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleresetpwd = false">取 消</el-button>
        <el-button type="primary" @click="ResetPwd">保存</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  getUserListPage,
  getRoleListPage,
  DeleteUserByIds,
  ResetUserPwd,
  editUser,
  addUser,
  GetRelationInfo,
  GetSchoolList,
  GetUserIdentityNameType,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      filters: {
        name: "",
      },
      newpwd: "",
      users: [],
      roles: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      PageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      dialogVisibleresetpwd: false,
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        uLoginName: [
          { required: true, message: "请输入登录名", trigger: "blur" },
        ],
        uRealName: [{ required: true, message: "请输入昵称", trigger: "blur" }],
        BirthdayTime: [
          { required: true, message: "请填写生日", trigger: "blur" },
        ],
      },
      //编辑界面数据
      editForm: {
        id: 0,
        uID: 0,
        RIDs: 0,
        uLoginName: "",
        uRealName: "",
        name: "",
        sex: -1,
        age: 0,
        BirthdayTime: "",
        Address: "",
        UserIdentity: [],
        SchoolId: "",
        Phone: "",
      },
      userIdentity: null,
      userIdentityList: [],

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        uLoginName: [
          { required: true, message: "请输入登录名", trigger: "blur" },
        ],
        uRealName: [{ required: true, message: "请输入昵称", trigger: "blur" }],
        uLoginPWD: [{ required: true, message: "请输入密码", trigger: "blur" }],
        BirthdayTime: [
          { required: true, message: "请填写生日", trigger: "blur" },
        ],
      },
      //新增界面数据
      addForm: {
        name: "",
        uLoginName: "",
        uRealName: "",
        uLoginPWD: "",
        sex: -1,
        age: 0,
        BirthdayTime: "",
        Address: "",
        UserIdentity: [],
        SchoolId: "",
        Phone: "",
      },
      SchoolList: [],
      userInfo: {},
      relevanceDialogVisible: false,
      relevance: {},
      userOptions: [
        {
          Id: 0,
          name: "管理员",
        },
        {
          Id: 1,
          name: "园长",
        },
        {
          Id: 2,
          name: "教师",
        },
        {
          Id: 3,
          name: "家长",
        },
      ],
      phone: "",
      identityValue: -1,
    };
  },
  methods: {
    onChangeIdentity(val) {
      this.page = 1;
      this.identityValue = val;
      this.getUsers();
    },
    async GetUserIdentityNameType() {
      let res = await GetUserIdentityNameType();
      if (res.data.success) {
        this.userIdentityList = res.data.response;
      }
    },
    //重置密码
    ResetPwd() {
      var ids = this.sels.map((x) => x.uID);

      ResetUserPwd({ Ids: ids, PassWord: this.newpwd }).then((res) => {
        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.dialogVisibleresetpwd = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    async onScrollData() {
      let res = await GetSchoolList();
      if (res.data.success) {
        this.SchoolList = res.data.response;
        getRoleListPage({
          uId: this.userInfo.uID,
          SchoolId: this.editForm.SchoolId,
        }).then((res) => {
          this.roles = res.data.response.data;
        });
      }
    },
    // 查看关联
    async onClickOpen(item) {
      let res = await GetRelationInfo({ userId: item.uID });
      //console.log(res);
      if (res.data.success) {
        this.relevance = res.data.response;
        if (
          res.data.response.RelationInfo_Students ||
          res.data.response.RelationInfo_Teachers
        ) {
          this.relevanceDialogVisible = true;
        } else {
          this.$message({
            type: "error",
            message: "暂无关联信息",
          });
        }
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //性别显示转换
    formatSex: function (row, column) {
      return row.sex == 1 ? "男" : row.sex == 0 ? "女" : "未知";
    },
    formatBirthdayTime: function (row, column) {
      return !row.BirthdayTime || row.BirthdayTime == ""
        ? ""
        : util.formatDate.format(new Date(row.BirthdayTime), "yyyy-MM-dd");
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getUsers();
    },
    //获取用户列表
    getUsers() {
      let para = {
        PageIndex: this.page,
        PageSize: this.PageSize,
        key: this.filters.name,
        uid: this.userInfo.uID,
        Phone: this.phone,
        identity: this.identityValue,
      };
      this.listLoading = true;

      getUserListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //重置密码
    onEmtyPass() {
      if (this.sels == null || this.sels.length <= 0) {
        this.$message({
          message: "请选择用户！",
          type: "error",
        });
        return;
      }
      this.dialogVisibleresetpwd = true;
    },
    //显示编辑界面
    async onClickEdit(row) {
      this.editFormVisible = true;
      this.onScrollData();
      this.editForm = Object.assign({}, row);
      //console.log(row);
      let str = this.editForm.UserIdentity.split(";");
      this.editForm.UserIdentity = str.map(Number);

      this.editForm = {
        uID: row.uID,
        RIDs: row.RIDs,
        uLoginName: row.uLoginName,
        uRealName: row.uRealName,
        sex: row.sex,
        age: 0,
        BirthdayTime: row.BirthdayTime,
        Address: row.Address,
        UserIdentity: this.editForm.UserIdentity,
        SchoolId: row.SchoolId,
        UserType: row.UserType,
        IsManage: row.IsManage,
        AvatarUrl: row.AvatarUrl,
        Phone: row.Phone,
      };
      //console.log(this.editForm, "AAAAAAAAAAA");

      getRoleListPage({
        uId: this.userInfo.uID,
        SchoolId: this.editForm.SchoolId,
      }).then((res) => {
        this.roles = res.data.response.data;
      });
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        name: "",
        uLoginName: "",
        uRealName: "",
        uLoginPWD: "",
        sex: -1,
        age: 0,
        BirthdayTime: "",
        Address: "",
        UserIdentity: [],
        SchoolId: "",
      };
      // getRoleListPage({
      //   uId: this.userInfo.uID,
      //   SchoolId: this.userInfo.SchoolId,
      // }).then((res) => {
      //   this.roles = res.data.response.data;
      // });
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            this.editForm.UserIdentity = this.editForm.UserIdentity.join(";");
            let para = Object.assign({}, this.editForm);

            para.BirthdayTime =
              !para.BirthdayTime || para.BirthdayTime == ""
                ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                : util.formatDate.format(
                    new Date(para.BirthdayTime),
                    "yyyy-MM-dd"
                  );
            //console.log(para);
            editUser(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getUsers();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let str = this.addForm.UserIdentity.join(";");
            this.addForm.UserIdentity = str;
            this.addForm.SchoolId = this.userInfo.SchoolId;
            //console.log(this.addForm, "this.addForm");
            let para = Object.assign({}, this.addForm);
            para.BirthdayTime =
              !para.BirthdayTime || para.BirthdayTime == ""
                ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                : util.formatDate.format(
                    new Date(para.BirthdayTime),
                    "yyyy-MM-dd"
                  );
            //console.log(para);
            addUser(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getUsers();
              } else {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function () {
      // return;
      var ids = this.sels.map((item) => item.uID);
      //console.log(ids);
      this.$confirm("确认删除选中记录吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { ids: ids };

          DeleteUserByIds(para).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getUsers();
            } else {
              this.$message({
                message: "删除失败",
                type: "error",
              });
            }
            //console.log(res);
          });
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.userInfo = JSON.parse(
      window.localStorage.user ? window.localStorage.user : null
    );
    this.getUsers();
    this.GetUserIdentityNameType();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    //console.log(this.buttonList, "this.buttonList");
  },
};
</script>

<style scoped>
.toolbar {
  margin-top: 20px;
}
</style>
